<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="width:100%;height:40px;margin-bottom:10px;">
            <div class="top_buttons" style="float:left;">
                <el-button icon="el-icon-upload2" type="primary" @click="import_tasks">导入任务</el-button>
            </div>
            <div class="search" style="float:right;">
                <el-form :inline="true" :model="formInline" @submit.native.prevent>
                <el-form-item>
                <el-input
                placeholder="请输入搜索信息"
                v-model="formInline.search_info"
                @keyup.native.enter="search"
                clearable>
                </el-input>
                </el-form-item>
                <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
                </el-form-item>
                </el-form>
            </div>
        </div>
        <el-table
        :data="task_list"
        style="width: 100%"
        stripe
        border>
            <!-- <el-table-column prop="id" label="序号" min-width="5%"></el-table-column> -->
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="task_name" label="任务名称" min-width="25%">
                <template slot-scope="scope">
                    <span style="font-weight:bold;">{{ scope.row.task_name }}</span>
                    <span v-if="scope.row.mana_survey==1" style="margin-left:5px;font-size:12px;color:#67C23A;font-weight:bold;border:1px solid #67C23A;border-radius:3px;">调</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="company" label="参与公司" min-width="8%"></el-table-column>
            <el-table-column prop="department" label="参与部门" min-width="8%" v-if="system_type==1"></el-table-column>
            <el-table-column prop="effective_date" label="开始日期" min-width="8%"></el-table-column>
            <el-table-column prop="expiration_date" label="结束日期" min-width="8%"></el-table-column> -->
            <el-table-column prop="user_status" label="名单导入状态" min-width="9%" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.user_status=='success'"><i class="el-icon-success" style="color:#67C23A;"></i></span>
                    <span v-else-if="scope.row.user_status=='failed'"><i class="el-icon-error" style="color:#F56C6C;"></i></span>
                    <span v-else>{{ scope.row.user_status }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="mana_ques_status" label="管理基本功评估导入状态" min-width="13%" v-if="system_type==1" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.mana_ques_status=='success'"><i class="el-icon-success" style="color:#67C23A;"></i></span>
                    <span v-else-if="scope.row.mana_ques_status=='failed'"><i class="el-icon-error" style="color:#F56C6C;"></i></span>
                    <span v-else>{{ scope.row.mana_ques_status }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="mana_survey_status" label="管理痛点调研导入状态" min-width="12%" v-if="system_type==1" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.mana_survey_status=='success'"><i class="el-icon-success" style="color:#67C23A;"></i></span>
                    <span v-else-if="scope.row.mana_survey_status=='failed'"><i class="el-icon-error" style="color:#F56C6C;"></i></span>
                    <span v-else>{{ scope.row.mana_survey_status }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="health_survey_status" label="组织健康度调研导入状态" min-width="13%" v-if="system_type==2" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.health_survey_status=='success'"><i class="el-icon-success" style="color:#67C23A;"></i></span>
                    <span v-else-if="scope.row.health_survey_status=='failed'"><i class="el-icon-error" style="color:#F56C6C;"></i></span>
                    <span v-else>{{ scope.row.health_survey_status }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="pain_spots_status" label="管理痛点调研导入状态" min-width="12%" v-if="system_type==2" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.pain_spots_status=='success'"><i class="el-icon-success" style="color:#67C23A;"></i></span>
                    <span v-else-if="scope.row.pain_spots_status=='failed'"><i class="el-icon-error" style="color:#F56C6C;"></i></span>
                    <span v-else>{{ scope.row.pain_spots_status }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="behavior_status" label="离职倾向问卷导入状态" min-width="12%" v-if="system_type==3" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.behavior_status=='success'"><i class="el-icon-success" style="color:#67C23A;"></i></span>
                    <span v-else-if="scope.row.behavior_status=='failed'"><i class="el-icon-error" style="color:#F56C6C;"></i></span>
                    <span v-else>{{ scope.row.behavior_status }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="job_motivation_status" label="工作动机评估导入状态" min-width="12%" v-if="system_type==3" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.job_motivation_status=='success'"><i class="el-icon-success" style="color:#67C23A;"></i></span>
                    <span v-else-if="scope.row.job_motivation_status=='failed'"><i class="el-icon-error" style="color:#F56C6C;"></i></span>
                    <span v-else>{{ scope.row.job_motivation_status }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="incentive_resource_status" label="激励资源评估导入状态" min-width="12%" v-if="system_type==3" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.incentive_resource_status=='success'"><i class="el-icon-success" style="color:#67C23A;"></i></span>
                    <span v-else-if="scope.row.incentive_resource_status=='failed'"><i class="el-icon-error" style="color:#F56C6C;"></i></span>
                    <span v-else>{{ scope.row.incentive_resource_status }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="task_import_status" label="任务导入状态" min-width="9%" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.task_import_status=='success'"><i class="el-icon-success" style="color:#67C23A;"></i></span>
                    <span v-else-if="scope.row.task_import_status=='failed'"><i class="el-icon-error" style="color:#F56C6C;"></i></span>
                    <span v-else>{{ scope.row.task_import_status }}</span>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin-top:10px;" v-if="task_list.length > 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageinfo.count"
                :page-sizes="pageinfo.page_sizes"
                :page-size="pageinfo.page_size"
                layout="total, sizes, prev, pager, next"
                :total="pageinfo.count">
            </el-pagination>
        </div>
        <el-dialog title="上传文件" :visible.sync="task_dialogFormVisible" width="600px" :destroy-on-close="true" :close-on-click-modal="false">
            <el-upload
                ref="uploadExcel"
                :auto-upload="false"
                accept=".xlsx"
                :on-change="fileChange"
                :on-remove="fileRemove"
                :file-list="fileList"
                :limit=limitNum
                :on-exceed="exceedFile">
                <el-button plain>选择文件</el-button>
                <div slot="tip" class="el-upload__tip">*只能上传一个.xlsx文件，且不超过10M。</div>
            </el-upload>
            <div style="margin-top:20px;">
                <el-button @click="dialogCancel">取 消</el-button>
                <el-button type="primary" @click="uploadFile">立即上传</el-button>
            </div>
        </el-dialog>
        <div style="text-align:left;margin-top:15px;">
            <el-button icon="el-icon-upload2" type="primary" @click="import_users">导入名单</el-button>
            <el-button icon="el-icon-upload2" type="primary" @click="import_ques('mana_ques_v1')" style="margin-left:10px;" v-if="system_type==1">导入管理基本功评估</el-button>
            <el-button icon="el-icon-upload2" type="primary" @click="import_ques('mana_survey_v1')" style="margin-left:10px;" v-if="system_type==1">导入管理痛点调研</el-button>
            <el-button icon="el-icon-upload2" type="primary" @click="import_ques('health_v2')" style="margin-left:10px;" v-if="system_type==2">导入组织健康度调研</el-button>
            <el-button icon="el-icon-upload2" type="primary" @click="import_ques('pain_spot_v2')" style="margin-left:10px;" v-if="system_type==2">导入管理痛点调研</el-button>
            <el-button icon="el-icon-upload2" type="primary" @click="import_ques('behavior_v3')" style="margin-left:10px;" v-if="system_type==3">导入离职倾向问卷</el-button>
            <el-button icon="el-icon-upload2" type="primary" @click="import_ques('motivation_v3')" style="margin-left:10px;" v-if="system_type==3">导入工作动机评估</el-button>
            <el-button icon="el-icon-upload2" type="primary" @click="import_ques('resource_v3')" style="margin-left:10px;" v-if="system_type==3">导入激励资源评估</el-button>
        </div>
        <el-dialog title="上传文件" :visible.sync="dialogFormVisible" width="600px" :destroy-on-close="true" :close-on-click-modal="false">
            <el-upload
                ref="uploadExcel2"
                :auto-upload="false"
                accept=".xlsx"
                :on-change="fileChange2"
                :on-remove="fileRemove2"
                :file-list="fileList2"
                multiple>
                <el-button plain>选择文件</el-button>
                <div slot="tip" class="el-upload__tip">*只能上传.xlsx文件，且不超过10M，支持多选。</div>
            </el-upload>
            <div style="margin-top:20px;">
                <el-button @click="dialogCancel2">取 消</el-button>
                <el-button type="primary" @click="uploadFile2">立即上传</el-button>
            </div>
        </el-dialog>
    </div>   
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    beforeCreate() {
        getdata.getList("checklogin")
              .then(resp => {
                // 增加处理，非管理员用户不能登录任务管理页面
                if(resp.data.usertype != 'admin'){
                    this.$router.push({
                        name: 'notFound',
                    });
                }
              })
              .catch(() => {
                if(localStorage.getItem("token") != null){
                    this.$message({
                        message: '会话超时，请重新登录！',
                        type: 'warning',
                    })
                }
                if(this.$route.path.includes('/JK')) {
                    this.$router.push({
                        path: '/JKlogin',
                    });
                }else if(this.$route.path.includes('/RC')) {
                    this.$router.push({
                        path: '/RClogin',
                    });
                }else{
                    this.$router.push({
                        path: '/login',
                    });
                }
              })
    },
    created() {
        this.getTaskInfo();
    },
    data() {
        return {
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 10,
                page_sizes: [1, 10, 20, 50, 100],
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            task_list: [],
            task_dialogFormVisible: false,
            dialogFormVisible: false,
            fileList: [],
            fileList2: [],
            task_file: '',
            system_type: 1,
            limitNum: 1,
            import_ques_type: '',
        }
    },
    methods: {
        import_users() {
            this.import_ques_type = 'users';
            this.dialogFormVisible = true;
        },
        import_ques(ques_type) {
            this.import_ques_type = ques_type;
            this.dialogFormVisible = true;
        },
        // 文件超出个数限制时的钩子
        exceedFile(files, fileList) {
            this.$message({
                type: 'error',
                message: `最多只能选择 ${this.limitNum} 个文件！`
            });
        },
        import_tasks() {
            this.task_dialogFormVisible = true;
        },
        dialogCancel() {
            // 增加处理，重新读取从后端传递过来的原始记录进行覆盖----从后台读取数据时，直接取消即可
            this.task_dialogFormVisible = false;
            this.fileList = [];  
        },
        dialogCancel2() {
            // 增加处理，重新读取从后端传递过来的原始记录进行覆盖----从后台读取数据时，直接取消即可
            this.dialogFormVisible = false;
            this.fileList = [];  
        },
        uploadFile() {
            // 增加loading效果
            const loading = this.$loading({
                lock: true, // lock的修改符--默认是false
                text: '正在导入，请稍后...', // 显示在加载图标下方的加载文案
                spinner: 'el-icon-loading', // 自定义加载图标类名
                background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
                })
            // 利用axios请求upload_url指定的后台接口进行上传
            // this.$refs.uploadExcel.submit()----这个方法好像没啥用！
            let formData = new FormData();
            let params = {
                task_id: this.task_id,
            }
            formData.append('file', this.task_file)
            postdata.uploadFilesP("importMultiTasks", formData, params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                        message: "导入完成！",
                        type: "success",
                        duration: 1500,
                    })
                }else{                    
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                    })
                }
                loading.close();
                this.task_dialogFormVisible = false;
                this.fileList = [];
                this.search()
            })
            .catch(() => {
                loading.close();
                this.task_dialogFormVisible = false;
                this.fileList = [];
            })
        },
        uploadFile2() {
            // 增加loading效果
            const loading = this.$loading({
                lock: true, // lock的修改符--默认是false
                text: '正在导入，请稍后...', // 显示在加载图标下方的加载文案
                spinner: 'el-icon-loading', // 自定义加载图标类名
                background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
                })
            // 利用axios请求upload_url指定的后台接口进行上传
            // this.$refs.uploadExcel.submit()----这个方法好像没啥用！
            let formData = new FormData();
            let params = {
                task_id: this.task_id,
                import_ques_type: this.import_ques_type,
                system_type: this.system_type,
            }
            this.fileList2.forEach((file) => {formData.append('files', file.raw)});   // 这里也能append需要往后台传递的额外参数
            postdata.uploadFilesP("importMultiQues", formData, params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                        message: "导入完成！",
                        type: "success",
                        duration: 1500,
                    })
                }else{                    
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                    })
                }
                loading.close();
                this.dialogFormVisible = false;
                this.fileList2 = [];
                this.search()
            })
            .catch(() => {
                loading.close();
                this.dialogFormVisible = false;
                this.fileList2 = [];
            })
        },
        fileChange(file) {
            this.task_file = file.raw;
            // this.fileList.push(file.raw);   // 每次上传文件变动时，将新文件添加到文件列表中
            // console.log('fileList add:', this.fileList);
            // console.log('self fileList:', fileList);
        },
        fileRemove(file) {
            this.task_file = file.raw;
            // this.fileList = this.fileList.filter(item => item.name != file.name);  // 每次删除文件时，将文件从文件列表中移除
            // console.log('fileList remove:', this.fileList);
            // console.log('self fileList:', fileList);
        },
        fileChange2(file, fileList) {
            this.fileList2 = fileList;
            // this.fileList.push(file.raw);   // 每次上传文件变动时，将新文件添加到文件列表中
            // console.log('fileList add:', this.fileList);
            // console.log('self fileList:', fileList);
        },
        fileRemove2(file, fileList) {
            this.fileList2 = fileList;
            // this.fileList = this.fileList.filter(item => item.name != file.name);  // 每次删除文件时，将文件从文件列表中移除
            // console.log('fileList remove:', this.fileList);
            // console.log('self fileList:', fileList);
        },
        // beforeUploadFile(file) {
        //     // console.log('before upload')
        //     // console.log(file)
        //     let extension = file.name.substring(file.name.lastIndexOf('.')+1)
        //     let size = file.size / 1024 / 1024
        //     if(extension !== 'xlsx') {
        //         this.$message({
        //         title: 'error',
        //         message: `只能上传.xlsx后缀的文件`
        //         });
        //     }
        //     if(size > 10) {
        //         this.$message({
        //         title: 'error',
        //         message: `文件大小不得超过10M`
        //         });
        //     }
        // },
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            // console.log('page_size: ' + this.pageinfo.page_size);
            if(this.formInline.search_info==''){
                this.getTaskInfo();
            }else{
                this.getTaskInfo(this.formInline.search_info);
            }
            // console.log(this.pageinfo.page_size)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            // console.log('current: ' + this.pageinfo.current);
            if(this.formInline.search_info==''){
                this.getTaskInfo();
            }else{
                this.getTaskInfo(this.formInline.search_info);
            }
            // console.log(this.pageinfo.current)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        getTaskInfo(query_info) {
            query_info = query_info||'';
            if(this.$route.path.includes('/RC')) {
                this.system_type = 3;
            }else if(this.$route.path.includes('/JK')) {
                this.system_type = 2;
            }else{
                this.system_type = 1;
            }
            let params;
            params = {
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
                query_info: query_info,
                system_type: this.system_type,
            }
            getdata.getListP("getMultiTasks", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.task_list = resp.data.data;
                        this.pageinfo.count = resp.data.count;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        search() {
            // console.log('this.pageinfo.current: ' + this.pageinfo.current);
            this.getTaskInfo(this.formInline.search_info);
        },
    }
}
</script>

<style scoped>
/* .el-table {
    font-size: 18px;
} */
.top_buttons > .el-button {
    font-size: 16px;
    /* font-weight: bold; */
}
.search /deep/ .el-input {
    font-size: 16px;
}
.search /deep/ .el-button {
    font-size: 16px;
}
.search /deep/ .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
}
/* .el-button {
    font-size: 18px;
} */
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
/* .search /deep/ .el-input {
    font-size: 18px;
}
.search /deep/ .el-input__inner {
    height: 45px;
    line-height: 45px;
}
::v-deep .el-pagination span, ::v-deep .el-pagination button, ::v-deep .el-pager li {
    font-size: 18px;
    line-height: 45px;
    height:45px;
}
::v-deep .el-pagination__sizes .el-input .el-input__inner, ::v-deep .el-select .el-input .el-select__caret {
    font-size: 18px;
} */
.assessee_dialog /deep/ .el-dialog__header {
    text-align: left;
}
.assessee_dialog /deep/ .el-dialog__body {
    padding: 20px 20px 0px 20px;
}
.dialog_form /deep/ .el-input {
    /* width: 223.67px; */
    width: 400px;
}
/* ::v-deep .el-input--mini .el-input__icon {
    line-height: 45px;
} */
.delete_button {
    margin-left: 10px;
}
::v-deep .el-form-item {
    margin-bottom: 0;
}
/* ::v-deep .el-table__header {
    font-size: 16px;
} */
.dialog_form /deep/ .el-form-item {
    margin-bottom: 14px;
}
.dialog_form /deep/ .el-textarea__inner {
    font-family: Avenir,Helvetica,Arial,sans-serif;
}
::v-deep .el-alert__title {
    font-size: 16px;
}
.dialog_form /deep/ .el-alert__title {
    font-size: 14px;
}
::v-deep .el-dialog__footer {
    text-align: center;
}
.notStart_status {
    font-size: 12px;
    background: #E6A23C;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.finished_status {
    font-size: 12px;
    background: #67C23A;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.inProgress_status {
    font-size: 12px;
    background: #409EFF;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.invalid_status {
    font-size: 12px;
    background: #909399;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
}
.mana_survey /deep/ .el-form-item__content {
    text-align: left;
    padding-left: 20px;
}
.el-upload__tip {
    font-size: 16px;
    color: #f56c6c;
}
::v-deep .el-upload-list__item-name {
    font-size: 16px;
    text-align: left;
}
::v-deep .el-dialog__header {
    text-align: left;
}
</style>